// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1yBkX","insightsList":"newBusinessInsightsMenu_insightsList__22GuJ","active":"newBusinessInsightsMenu_active__2_YPW"};